import WagesTablePage from "./WagesTablePage";

export default WagesTablePage;